import { MutationCache, QueryClient } from "@tanstack/react-query";
import { toast } from "@/state/toast.store";

/** Surface any mutation error as a toast unless the caller handled it itself
 *  (set `meta: { silent: true }` on the mutation to opt out). */
const mutationCache = new MutationCache({
  onError: (error, _vars, _ctx, mutation) => {
    if (mutation.meta?.silent) return;
    const message = error instanceof Error ? error.message : "Er ging iets mis. / Something went wrong.";
    toast.err(message);
  },
});

export const queryClient = new QueryClient({
  mutationCache,
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
